import { Translate } from '@change-corgi/core/react/i18n';
import { DesignSystemLegacy } from '@change-corgi/design-system-legacy/core';
import { createModalHook } from '@change-corgi/design-system-legacy/modals';
import { sunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import type { SessionUser } from 'src/shared/session';

import { LoginModalBody } from './components/LoginModalBody';

export const useLoginModal = createModalHook<
	{
		user?: SessionUser;
		googleAuthEnabled: boolean;
		showContinueAsGuest: boolean;
		email: string;
		isSunriseEnabled: boolean;
	},
	{ user: SessionUser | undefined; continueAsGuest?: boolean }
>({
	name: 'PromotePageLoginModal',
	stylesOverrides: {
		width: 420,
	},
	heading: function PromotePageLoginModalHeading({ initialFocusAttributes, options }) {
		// This is to match fe's UI (big centered title)
		return (
			<DesignSystemLegacy theme={options.isSunriseEnabled ? sunriseTheme : undefined}>
				<Heading
					as="h1"
					size={['subtitle', 'h3']}
					sx={{ textAlign: 'center' }}
					mb={16}
					color={options.isSunriseEnabled ? 'sunrise.semantic.typography.strong' : undefined}
					{...initialFocusAttributes}
				>
					<Translate value="fe.components.login_or_join.log_in" />
				</Heading>
			</DesignSystemLegacy>
		);
	},
	body: function PromotePageLoginModalBody({ options, closeModal }) {
		return (
			<DesignSystemLegacy theme={options.isSunriseEnabled ? sunriseTheme : undefined}>
				<LoginModalBody
					user={options.user}
					email={options.email}
					showContinueAsGuest={options.showContinueAsGuest}
					googleAuthEnabled={options.googleAuthEnabled}
					isSunriseEnabled={options.isSunriseEnabled}
					onSuccess={(user) => closeModal({ user })}
					onContinueAsGuest={() => closeModal({ user: undefined, continueAsGuest: true })}
				/>
			</DesignSystemLegacy>
		);
	},
});
